import { Card, Col, Row, Typography, theme as antdTheme } from 'antd';
import {
  AlertOutlined,
  FileProtectOutlined,
  IdcardOutlined,
  NotificationOutlined,
  RightOutlined,
  SolutionOutlined,
  UserAddOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router';
import { PageHeader } from '@/shared/components/page-header';

interface Tile {
  to: string;
  title: string;
  description: string;
  icon: React.ReactNode;
}

const tiles: Tile[] = [
  {
    to: '/frontdesk/visitors',
    title: 'Visitors',
    description: 'Sign-in / sign-out the day’s visitors. Each entry is issued a printable pass number.',
    icon: <IdcardOutlined />,
  },
  {
    to: '/frontdesk/inquiries',
    title: 'Admission inquiries',
    description: 'Walk-ins, calls, referrals. Track follow-ups through to enrollment.',
    icon: <UserAddOutlined />,
  },
  {
    to: '/frontdesk/complaints',
    title: 'Complaints',
    description: 'Lodge, assign, and resolve concerns from parents, students, and staff.',
    icon: <AlertOutlined />,
  },
  {
    to: '/frontdesk/issuances',
    title: 'Document issuance',
    description: 'TC, character, bonafide. Sequential numbering per type with reissue tracking.',
    icon: <FileProtectOutlined />,
  },
  {
    to: '/frontdesk/notices',
    title: 'Notices & announcements',
    description: 'Post by category and audience — all, staff, students, or a class.',
    icon: <NotificationOutlined />,
  },
  {
    to: '/frontdesk/document-types',
    title: 'Document types',
    description: 'Catalog of certificates the school issues; managed by the front-desk admin.',
    icon: <SolutionOutlined />,
  },
];

export function FrontDeskHubPage() {
  const { token } = antdTheme.useToken();
  return (
    <div style={{ display: 'grid', gap: 22 }}>
      <PageHeader
        eyebrow="Module"
        title="Front Desk"
        description="Reception, admissions intake, complaints, certificates, and notices."
      />

      <Row gutter={[16, 16]}>
        {tiles.map((t) => (
          <Col key={t.to} xs={24} md={12} xl={8}>
            <Link to={t.to} style={{ textDecoration: 'none' }}>
              <Card
                hoverable
                className="lift-card"
                style={{ height: '100%', borderColor: token.colorBorderSecondary }}
                styles={{ body: { padding: 20 } }}
              >
                <div style={{ display: 'flex', gap: 14 }}>
                  <span
                    style={{
                      width: 40,
                      height: 40,
                      borderRadius: 10,
                      display: 'grid',
                      placeItems: 'center',
                      background: token.colorFillTertiary,
                      color: token.colorPrimary,
                      fontSize: 18,
                      flexShrink: 0,
                    }}
                  >
                    {t.icon}
                  </span>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8 }}>
                      <Typography.Text strong style={{ fontSize: 15 }}>
                        {t.title}
                      </Typography.Text>
                      <RightOutlined style={{ fontSize: 12, color: token.colorTextTertiary }} />
                    </div>
                    <Typography.Text type="secondary" style={{ fontSize: 13, display: 'block', marginTop: 4 }}>
                      {t.description}
                    </Typography.Text>
                  </div>
                </div>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
